import { useState, useEffect } from 'react';
import { getDomains, addDomain, deleteDomain } from '../api';

export default function Domains({ refreshKey }) {
  const [domains, setDomains] = useState([]);
  const [newDomain, setNewDomain] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    setError('');

    getDomains()
      .then(data => {
        setDomains(data);
      })
      .catch(err => {
        console.error('Failed to fetch domains:', err);
        setError('Failed to load domains. Please try again.');
      })
      .finally(() => setLoading(false));

    return () => {};
  }, [refreshKey]);

  const handleAdd = async () => {
    const trimmedDomain = newDomain.trim();
    if (!trimmedDomain) {
      setError('Please enter a domain');
      return;
    }
    
    setError('');
    try {
      await addDomain(trimmedDomain);
      const updatedDomains = await getDomains();
      setDomains(updatedDomains);
      setNewDomain('');
    } catch (error) {
      console.error('Failed to add domain:', error);
      if (error.response) {
        setError(error.response.data.error || 'Failed to add domain');
      } else {
        setError('Failed to add domain. Please try again.');
      }
    }
  };

  const handleDelete = async (domain) => {
    try {
      await deleteDomain(domain);
      const updatedDomains = await getDomains();
      setDomains(updatedDomains);
    } catch (error) {
      console.error('Failed to delete domain:', error);
      setError('Failed to delete domain. Please try again.');
    }
  };

  return (
    <div className="domain-manager">
      <form
        className="add-domain"
        onSubmit={(e) => {
          e.preventDefault();
          handleAdd();
        }}
      >
        <input
          type="text"
          value={newDomain}
          onChange={(e) => {
            setNewDomain(e.target.value);
            setError('');
          }}
          placeholder="Enter domain to whitelist"
          aria-label="Domain to whitelist"
          className="domain-input"
        />
        <button type="submit" className="domain-add-button">
          Add Domain
        </button>
      </form>

      {error && (
        <div className="domain-error">
          {error}
        </div>
      )}

      <h2>Whitelisted Domains</h2>
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th style={{ maxWidth: 'auto' }}>Domain</th>
              <th>Added At</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="3">Loading domains…</td>
              </tr>
            ) : (
              domains.map(({ domain, added_at }) => (
                <tr key={domain}>
                  <td style={{ maxWidth: 400 }}>{domain}</td>
                  <td>{new Date(added_at).toLocaleString()}</td>
                  <td style={{ display: 'flex', justifyContent: 'right', maxWidth: 300 }}>
                    <button
                      onClick={() => handleDelete(domain)}
                      className="delete-btn"
                      aria-label={`Remove ${domain}`}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
